// extracted by mini-css-extract-plugin
export default {"menu":"GroupBrandsStep_menu__2-Azg"};